<template lang="pug">
  section.section(@mouseleave="cambiarHover(false)")
    .content
      h4 Artículos Agregados
      .panel.list-group(v-show="hayDatos")
        a.panel-block.list-group-item(v-for="(data, index) in asignados") 
          .notification
            button.delete(@click="eliminarArt(data)")
            strong {{ data.modelo}}, 
            | &nbsp {{ data.marca}}
            br
            small {{ data.serie }}
        a.button.is-success.is-fullwidth(@click="irReasignar") Continuar
      .panel.list-group(v-show="!hayDatos")
        a.panel-block.list-group-item No hay Artículos Nuevos
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ListaArticulosAsignados',
  props: {
    asignados: {
      type: Array,
      default: []
    },
  },
  data () {
    return {
      hover: false,
      hayDatos: false
    }
  },
  watch: {
    asignados () {
      this.comprobarExisteArticulos()
    }
  },
  methods: {
    cambiarHover (valor) {
      this.hover = valor
      this.$emit('hover', this.hover)
    },
    eliminarArt (art) {
      // Eliminar en la Base de Dattos el item seleccionado
        // update la ubicación y resguardo, regresando al origen como ubicacion
      this.$emit('quitarArticulo_Asig', art)
    },
    comprobarExisteArticulos () {
      if (this.asignados.length > 0) {
        this.hayDatos = true
      } else {
        this.hayDatos = false
      }
    },
    irReasignar () {
      this.$store.commit('listaReasignar', this.asignados)
      this.$router.push('/Inventario/Reasignar')
    },
    
  },
  created () {
    this.comprobarExisteArticulos()
  }
}
</script>

<style scoped>
  .list-group > .list-group-item:first-child {
    border-radius: 4px 4px 0 0;
  }
  .list-group > .list-group-item:last-child {
    border-radius: 0 0 4px 4px;
  }
  .panel:not(:last-child) {
    margin-bottom: 0;
  }
  .notification {
    padding-bottom: 0.25rem;
    padding-top: 0.25rem;
  }
  .section {
    position: absolute;
    top: 10px;
    right: 0;
    z-index: 20;
    padding-right: 0;
  }

  .panel.list-group {
    background-color: whitesmoke;
  }

</style>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/ListaArticulosAsignados.vue